var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimetableRgbRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,35.5a10.4907,10.4907,0,0,1,17-8.2363V5a.9993.9993,0,0,0-1-1H9A.9993.9993,0,0,0,8,5V43a.9993.9993,0,0,0,1,1H27.3529A10.4758,10.4758,0,0,1,23,35.5ZM13,11H32v2H13Zm0,8H24v2H13ZM41.8593,37A8.496,8.496,0,1,1,32,27.1406V37ZM34,35V27.0254A8.4975,8.4975,0,0,1,41.9747,35Z",
    fill: "#d70511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimetableRgbRed);
export default __webpack_public_path__ + "static/media/timetable_rgb_red.f73bf78f6ebb9a95e85e7d6a6285c825.svg";
export { ForwardRef as ReactComponent };